export const AlertStatuses = {
    active: "active",
    confirmed: "confirmed",
    dismissed: "dismissed",
    expired: "expired",
    confirmed_with_action: "confirmed_with_action"
}


// WEBPACK FOOTER //
// ./src/constants/alert_statuses.js